<template>
  <div>
    <breadCrumb
      :icon="'fa-info'"
      :category="$t(`sideNav.navSalonReport`)"
      :subCategory="$t(`subMenu.salon_report_cdr`)"
      :subSubCategory="''"
    >
    </breadCrumb>
    <div class="px-3 px-sm-5 py-4">
      <div class="panel mb-0">
        <div class="panel-hdr d-flex border-bottom-0 pt-3 d-block">
          <div class="col-6">
            <div class="input-group">
              <div class="input-group-prepend w-100">
                <label class="input-group-text border-right-0">
                  <i class="fas fa-store"></i>
                </label>
                <multiselect
                  v-model="selectedOutlet"
                  label="text"
                  track-by="id"
                  :options="outlet"
                  :searchable="false"
                  :show-labels="false"
                  :allow-empty="false"
                  openDirection="below"
                  @select="filterByOutlet"
                >
                  <template slot="option" slot-scope="{ option }">{{
                    option.text
                  }}</template>
                </multiselect>
              </div>
            </div>
          </div>
            <div class="col-6">
                            <div class="input-group">
              <div class="input-group-prepend w-100">
                <label class="input-group-text border-right-0">
                  <b-icon icon="calendar"></b-icon>
                </label>
                 <b-form-input v-model="cdrDATE" type="date" placeholder="Select Date" @input="filterByDate"></b-form-input>
              </div>
            </div>
            </div>
        </div>
        <div class="d-flex mt-2 w-100">
                        <div class="col-6 pl-3">
                            <div class="input-group">
              <div class="input-group-prepend w-100">
                <label class="input-group-text border-right-0">
                  <b-icon icon="search"></b-icon>
                </label>
                 <b-form-input v-model="searchSalesID" type="text" placeholder="Search Sales ID"></b-form-input>
              </div>
            </div>
            </div>
        </div>
        <div class="panel-container show">
          <div class="panel-content">
            <div class="tab-content mt-2">
              <div>
                <div
                  v-if="isSpinnerShow"
                  class="d-flex justify-content-center mt-3 mb-3"
                >
                  <b-spinner label="Loading..."></b-spinner>
                </div>
                <div
                  class="panel-tag mt-3"
                  v-if="!isSpinnerShow && totalEntries == 0"
                >
                  {{ $t("table.no_records") }}
                </div>
                <div
                  v-if="!isSpinnerShow && totalEntries != 0"
                  class="dataTables_wrapper dt-bootstrap4"
                >
                  <div class="row justify-content-end">
                    <div class="col-auto pt-2">
                      <span>{{
                        $t("table.pagination", {
                          startPage: startPage,
                          endPage: endPage,
                          totalEntries: totalEntries,
                        })
                      }}</span>
                    </div>
                    <div class="col-auto">
                      <b-pagination
                        class="ml-3"
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="totalEntries"
                        @input="handlePagination"
                        aria-controls="tblCDR"
                      ></b-pagination>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 overflow-auto">
                      <b-table
                        small
                        striped
                        hover
                        bordered
                        :items="cdrItems"
                        :per-page="perPage"
                        :current-page="currentPage"
                        responsive="sm"
                      >
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  handleSessionExpired,
  setReturnData,
} from "../assets/js/dashboard/dashboard";
import BreadCrumb from "./dashboard/Bread_Crumb";
import moment from "moment";
export default {
  name: "CDR",
  components: {
    BreadCrumb,
  },
  watch:{
    searchSalesID(val){
      this.cdrItems = this.cdrClone.filter(i=>i.salesID.toString().includes(val));
      this.totalEntries = this.cdrItems.length;
      if(this.endPage > this.totalEntries){
        this.endPage = this.totalEntries;
      }
    }
  },
  computed: {
    fields() {
      return [
        { key: "index", label: "#", thClass: "thead-themed align-middle" },
        {
          key: "createDate",
          label: "Create Date",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "sentDate",
          label: "Sent Date",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "receiptDate",
          label: "Receipt Date",
          thClass: "thead-themed align-middle",
        },
        {
          key: "discount",
          label: "Discount",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "gst",
          label: "GST",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "outstanding",
          label: "Outstanding",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "serviceCharge",
          label: "Service Charge",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "void",
          label: "Void",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "sales",
          label: "Sales",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
        searchSalesID:"",
      selectedOutlet: {},
      isSpinnerShow: false,
      filterObj: {},
      outlet: [],
      cdrItems: [],
      cdrClone:[],
      exportData: [],
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,
      cdrDATE:""
    };
  },
  methods: {
        handlePagination(pg) {
      if (pg != null) {
         this.page = pg;
        this.startPage =((pg-1)*100)+1;
        this.endPage = pg * 100;
        if(this.endPage>this.totalEntries){
          this.endPage = this.totalEntries;
        }
      }
    },
    filterByDate(event){
      this.cdrDATE = event;
      this.getCdrItems();
    },
    filterByOutlet(event) {
      this.selectedOutlet = event;
      this.getCdrItems();
    },
    async getCdrItems() {
      let $vm = this;
      let QUERY_STRING = this.$api.CDR + "?date="+this.cdrDATE+"&outletID=" + this.selectedOutlet.id;
      const url = QUERY_STRING;
      var result = {};
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      var retData = setReturnData(result, result.length, this.page);
      this.totalEntries = result.length;
      this.totalPage = retData.totalPage;
      this.startPage = retData.startPage;
      this.endPage = retData.endPage;
      Object.assign(this.cdrClone,result);
      Object.assign(this.cdrItems,result);
      return result;
    },
  },
  async mounted() {
    this.cdrItems = await this.getCdrItems();
  },
  created() {
    this.outlet = JSON.parse(this.$store.state.outlets);
    this.selectedOutlet = this.outlet[0];
    this.cdrDATE = moment().format("YYYY-MM-DD")
  },
};
</script>